"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
var _classnames = _interopRequireDefault(require("classnames"));
var _context = require("../config-provider/context");
var _popover = _interopRequireDefault(require("../popover"));
var _icon = _interopRequireDefault(require("../icon"));
var _MenuContext = require("./MenuContext");
var _util = require("./util");
var _MenuItemGroup = _interopRequireDefault(require("./MenuItemGroup"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function hasChildWithKeys(menuItem, targetKeys) {
  // 检查当前节点的直接子节点
  if (menuItem.children && menuItem.children.length > 0) {
    var _iterator = _createForOfIteratorHelper(menuItem.children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        if (targetKeys.includes(child.key)) {
          return true;
        }
        // 递归检查子节点的子节点
        if (hasChildWithKeys(child, targetKeys)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return false;
}
var Menu = function Menu(props) {
  var _props$selectedKeys, _props$expandedKeys;
  var children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'inline' : _props$mode,
    _props$selectable = props.selectable,
    selectable = _props$selectable === void 0 ? true : _props$selectable,
    _props$defaultSelecte = props.defaultSelectedKeys,
    defaultSelectedKeys = _props$defaultSelecte === void 0 ? [] : _props$defaultSelecte,
    _props$defaultExpande = props.defaultExpandedKeys,
    defaultExpandedKeys = _props$defaultExpande === void 0 ? [] : _props$defaultExpande,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    _props$inlineIndent = props.inlineIndent,
    inlineIndent = _props$inlineIndent === void 0 ? 24 : _props$inlineIndent,
    _props$inlineBaseInde = props.inlineBaseIndent,
    inlineBaseIndent = _props$inlineBaseInde === void 0 ? 12 : _props$inlineBaseInde,
    onSelectChange = props.onSelectChange,
    onExpandChange = props.onExpandChange,
    _props$inlineCollapse = props.inlineCollapsed,
    inlineCollapsed = _props$inlineCollapse === void 0 ? false : _props$inlineCollapse,
    size = props.size,
    autoDestroy = props.autoDestroy,
    getContainer = props.getContainer,
    customPrefixCls = props.prefixCls,
    _props$triggerSubMenu = props.triggerSubMenuAction,
    triggerSubMenuAction = _props$triggerSubMenu === void 0 ? 'hover' : _props$triggerSubMenu,
    align = props.align;
  var _useContext = (0, _react.useContext)(_context.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls('menu', customPrefixCls);
  // 初始化selectedKeys和expandedKeys
  var _useState = (0, _react.useState)((_props$selectedKeys = props.selectedKeys) !== null && _props$selectedKeys !== void 0 ? _props$selectedKeys : defaultSelectedKeys),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedKeys = _useState2[0],
    setSelectedKeys = _useState2[1];
  var _useState3 = (0, _react.useState)((_props$expandedKeys = props.expandedKeys) !== null && _props$expandedKeys !== void 0 ? _props$expandedKeys : defaultExpandedKeys),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    expandedKeys = _useState4[0],
    setExpandedKeys = _useState4[1];
  var commonPopoverConfig = {
    showArrow: false,
    autoDestroy: autoDestroy,
    getContainer: getContainer,
    trigger: triggerSubMenuAction,
    align: align !== null && align !== void 0 ? align : {
      // inline模式下，inlineCollapsed时，子菜单会以浮层的形式展现
      offset: ['inline', 'vertical'].includes(mode) ? [8, -4] : [8, 4]
    }
  };
  // 监听mode和inlineCollapsed的变化，如果mode不是inline，而inlineCollapsed被设置了，发出警告
  (0, _react.useEffect)(function () {
    if ('inlineCollapsed' in props && mode !== 'inline') {
      console.warn("`inlineCollapsed` should only be used when Menu's `mode` is inline.");
    }
  }, [mode, inlineCollapsed]);
  // 监听props中selectedKeys和expandedKeys的变化
  (0, _react.useEffect)(function () {
    if ('selectedKeys' in props) {
      setSelectedKeys(props.selectedKeys);
    }
  }, [props.selectedKeys]);
  (0, _react.useEffect)(function () {
    if ('expandedKeys' in props) {
      setExpandedKeys(props.expandedKeys);
    }
  }, [props.expandedKeys]);
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    menuData = _useState6[0],
    setMenuData = _useState6[1];
  var handleSelect = function handleSelect(selectInfo) {
    if (selectable) {
      var selectedKey = selectInfo.key;
      if (!('selectedKeys' in props)) {
        setSelectedKeys([selectedKey]);
      }
      onSelectChange === null || onSelectChange === void 0 || onSelectChange(selectInfo.key, selectInfo.item, selectInfo.domEvent);
    }
  };
  var handleExpandedChange = function handleExpandedChange(event) {
    var expandedKeysSet = new Set(expandedKeys);
    if (expandedKeysSet.has(event.key)) {
      expandedKeysSet.delete(event.key);
    } else {
      expandedKeysSet.add(event.key);
    }
    var newExpandedKeys = Array.from(expandedKeysSet);
    if (!('expandedKeys' in props)) {
      setExpandedKeys(newExpandedKeys);
    }
    onExpandChange === null || onExpandChange === void 0 || onExpandChange(newExpandedKeys);
  };
  (0, _react.useEffect)(function () {
    setMenuData((0, _util.parseMenuItems)(children));
  }, [children]);
  /**
   * 判断子菜单是否有被选中，若选中，则激活父菜单
   * @param item
   */
  var getSubmenuActive = function getSubmenuActive(item) {
    return item.children.length > 0 && hasChildWithKeys(item, selectedKeys);
  };
  /**
   * 判断菜单项是否被选中
   * @param item
   */
  var getMenuItemSelected = function getMenuItemSelected(item) {
    // 如果包含子菜单
    if (item.children.length > 0) {
      if (mode === 'inline') {
        // inline菜单，折叠状态下，只有顶层菜单有选中状态
        if (inlineCollapsed) {
          return item.level === _util.TOP_LEVEL && getSubmenuActive(item);
        }
        // inline菜单，菜单收起状态下，父菜单有选中状态
        return !expandedKeys.includes(item.key) && getSubmenuActive(item);
      }
      if (mode === 'vertical') {
        // 垂直菜单，只有顶层菜单有选中状态
        return item.level === _util.TOP_LEVEL && getSubmenuActive(item);
      }
    }
    return selectedKeys.includes(item.key);
  };
  var renderBaseMenuItem = function renderBaseMenuItem(item) {
    var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _objectSpread(_objectSpread(_objectSpread({}, item.props), extraProps), {}, {
      key: item.key
    }), item.content);
  };
  /**
   * 渲染菜单组，仅支持inline和vertical模式
   * @param groupProps
   * @param _children
   */
  var renderBaseMenuItemWithGroup = function renderBaseMenuItemWithGroup(item, _children) {
    return /*#__PURE__*/_react.default.createElement(_MenuItemGroup.default, _objectSpread(_objectSpread({}, item.props), {}, {
      key: item.key
    }), _children);
  };
  /**
   * 渲染内联菜单
   * @param _menuData
   */
  var renderInlineMenu = function renderInlineMenu(_menuData) {
    if (_menuData.length === 0) {
      return null;
    }
    return _menuData.map(function (item) {
      if (item.nodeType === 'MenuItemGroup') {
        return renderBaseMenuItemWithGroup(item, renderInlineMenu(item.children));
      }
      var finalStyle = _objectSpread({}, item.props.style);
      // 非折叠模式下，inlineIndet才生效
      if (!inlineCollapsed) {
        finalStyle.paddingLeft = item.level * inlineIndent + inlineBaseIndent;
      }
      var containSubmenu = item.children.length > 0;
      var events = containSubmenu ? {
        onClick: function onClick(e) {
          var _item$props$onTitleCl, _item$props, _item$props$onClick, _item$props2;
          handleExpandedChange({
            key: item.key
          });
          (_item$props$onTitleCl = (_item$props = item.props).onTitleClick) === null || _item$props$onTitleCl === void 0 || _item$props$onTitleCl.call(_item$props, item.key, e);
          (_item$props$onClick = (_item$props2 = item.props).onClick) === null || _item$props$onClick === void 0 || _item$props$onClick.call(_item$props2, e);
        }
      } : {
        onClick: function onClick(e) {
          var _item$props$onClick2, _item$props3;
          handleSelect({
            key: item.key,
            item: item.props,
            domEvent: e
          });
          (_item$props$onClick2 = (_item$props3 = item.props).onClick) === null || _item$props$onClick2 === void 0 || _item$props$onClick2.call(_item$props3, e);
        }
      };
      var submenuWrapStyle = {};
      var isSubmenExpanded = containSubmenu && expandedKeys.includes(item.key);
      if (!isSubmenExpanded) {
        submenuWrapStyle.height = '0px';
      }
      var arrowIconClassName = (0, _classnames.default)("".concat(prefixCls, "-item-arrow"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-item-arrow-rotate"), isSubmenExpanded));
      var menuItemContent = renderBaseMenuItem(item, _objectSpread({
        style: finalStyle,
        active: getSubmenuActive(item) && item.level === _util.TOP_LEVEL,
        selected: getMenuItemSelected(item),
        description: containSubmenu ? ( /*#__PURE__*/_react.default.createElement(_icon.default, {
          className: arrowIconClassName,
          type: 'down-thick'
        })) : item.props.description
      }, events));
      // 折叠模式下
      if (inlineCollapsed) {
        if (containSubmenu) {
          var _item$props$popPlacem;
          var popClass = (0, _classnames.default)("".concat(prefixCls, "-popover ").concat(prefixCls, "-popover-").concat(mode), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, item.props.popClassName, !!item.props.popClassName), "".concat(prefixCls, "-popover-").concat(size), !!size));
          var placement = (_item$props$popPlacem = item.props.popPlacement) !== null && _item$props$popPlacem !== void 0 ? _item$props$popPlacem : 'rightTop';
          return /*#__PURE__*/_react.default.createElement(_popover.default, _objectSpread(_objectSpread({}, commonPopoverConfig), {}, {
            key: item.key,
            className: popClass,
            placement: placement,
            // inline模式，inlineCollapse时，子菜单以浮层的形式展现
            content: renderVerticalMenu(item.children)
          }), menuItemContent);
        }
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: item.key
        }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          message: item.content,
          placement: "right"
        }, menuItemContent), renderInlineMenu(item.children));
      }
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: item.key
      }, menuItemContent, containSubmenu && ( /*#__PURE__*/_react.default.createElement("ul", {
        className: "".concat(prefixCls, "-sub-wrap"),
        style: submenuWrapStyle
      }, renderInlineMenu(item.children))));
    });
  };
  /**
   * 渲染垂直菜单
   * @param _menuData
   */
  var renderVerticalMenu = function renderVerticalMenu(_menuData) {
    if (_menuData.length === 0) {
      return null;
    }
    return _menuData.map(function (item) {
      if (item.nodeType === 'MenuItemGroup') {
        return renderBaseMenuItemWithGroup(item, renderVerticalMenu(item.children));
      }
      if (item.children.length > 0) {
        var _item$props$popPlacem2;
        var popClass = (0, _classnames.default)("".concat(prefixCls, "-popover ").concat(prefixCls, "-popover-").concat(mode, " ").concat(prefixCls, "-popover-").concat(size), item.props.popClassName);
        var placement = (_item$props$popPlacem2 = item.props.popPlacement) !== null && _item$props$popPlacem2 !== void 0 ? _item$props$popPlacem2 : 'rightTop';
        return /*#__PURE__*/_react.default.createElement(_popover.default, _objectSpread(_objectSpread({}, commonPopoverConfig), {}, {
          key: item.key,
          className: popClass,
          placement: placement,
          content: renderVerticalMenu(item.children)
        }), renderBaseMenuItem(item, {
          active: getSubmenuActive(item),
          selected: getMenuItemSelected(item),
          // 含有子元素的菜单显示箭头
          description: ( /*#__PURE__*/_react.default.createElement(_icon.default, {
            type: 'right-thick'
          })),
          onClick: function onClick(e) {
            var _item$props$onTitleCl2, _item$props4, _item$props$onClick3, _item$props5;
            (_item$props$onTitleCl2 = (_item$props4 = item.props).onTitleClick) === null || _item$props$onTitleCl2 === void 0 || _item$props$onTitleCl2.call(_item$props4, item.key, e);
            (_item$props$onClick3 = (_item$props5 = item.props).onClick) === null || _item$props$onClick3 === void 0 || _item$props$onClick3.call(_item$props5, e);
          }
        }));
      }
      return renderBaseMenuItem(item, {
        active: getSubmenuActive(item),
        selected: getMenuItemSelected(item),
        onClick: function onClick(e) {
          var _item$props$onClick4, _item$props6;
          handleSelect({
            key: item.key,
            item: item.props,
            domEvent: e
          });
          (_item$props$onClick4 = (_item$props6 = item.props).onClick) === null || _item$props$onClick4 === void 0 || _item$props$onClick4.call(_item$props6, e);
        }
      });
    });
  };
  /**
   * 渲染水平菜单项的弹层
   * @param _menuData
   */
  var loopHorizontalPoperRender = function loopHorizontalPoperRender(_menuData) {
    if (_menuData.length === 0) {
      return null;
    }
    return _menuData.map(function (item) {
      if (item.children.length > 0) {
        var _item$props$popPlacem3;
        var popClass = (0, _classnames.default)("".concat(prefixCls, "-popover ").concat(prefixCls, "-popover-").concat(mode, " ").concat(prefixCls, "-popover-").concat(size), item.props.popClassName);
        var placement = (_item$props$popPlacem3 = item.props.popPlacement) !== null && _item$props$popPlacem3 !== void 0 ? _item$props$popPlacem3 : 'rightTop';
        return /*#__PURE__*/_react.default.createElement(_popover.default, _objectSpread(_objectSpread({}, commonPopoverConfig), {}, {
          key: item.key,
          className: popClass,
          placement: placement,
          content: loopHorizontalPoperRender(item.children)
        }), renderBaseMenuItem(item, {
          active: getSubmenuActive(item),
          selected: getMenuItemSelected(item),
          // 含有子元素的菜单显示箭头
          description: ( /*#__PURE__*/_react.default.createElement(_icon.default, {
            type: 'right-thick'
          }))
        }));
      }
      return renderBaseMenuItem(item, {
        active: getSubmenuActive(item),
        selected: getMenuItemSelected(item),
        onClick: function onClick(e) {
          var _item$props$onClick5, _item$props7;
          handleSelect({
            key: item.key,
            item: item.props,
            domEvent: e
          });
          (_item$props$onClick5 = (_item$props7 = item.props).onClick) === null || _item$props$onClick5 === void 0 || _item$props$onClick5.call(_item$props7, e);
        }
      });
    });
  };
  /**
   * 渲染横向菜单
   * @param _menuData
   */
  var renderHorizontalMenu = function renderHorizontalMenu(_menuData) {
    if (_menuData.length === 0) {
      return null;
    }
    return _menuData.map(function (item) {
      // 有子菜单时
      if (item.children.length > 0) {
        var _item$props$popPlacem4;
        var popClass = (0, _classnames.default)("".concat(prefixCls, "-popover ").concat(prefixCls, "-popover-").concat(mode, " ").concat(prefixCls, "-popover-").concat(size), item.props.popClassName);
        var placement = (_item$props$popPlacem4 = item.props.popPlacement) !== null && _item$props$popPlacem4 !== void 0 ? _item$props$popPlacem4 : 'bottom';
        var isSubmenExpanded = expandedKeys.includes(item.key);
        var arrowIconClassName = (0, _classnames.default)("".concat(prefixCls, "-item-arrow"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-item-arrow-rotate"), isSubmenExpanded));
        return /*#__PURE__*/_react.default.createElement(_popover.default, _objectSpread(_objectSpread({}, commonPopoverConfig), {}, {
          key: item.key,
          className: popClass,
          placement: placement,
          content: loopHorizontalPoperRender(item.children)
        }), renderBaseMenuItem(item, {
          active: getSubmenuActive(item),
          selected: getMenuItemSelected(item),
          prefixCls: "".concat(prefixCls, "-horizontal"),
          description: ( /*#__PURE__*/_react.default.createElement(_icon.default, {
            className: arrowIconClassName,
            type: 'down-thick'
          })),
          onClick: function onClick(e) {
            var _item$props$onTitleCl3, _item$props8, _item$props$onClick6, _item$props9;
            (_item$props$onTitleCl3 = (_item$props8 = item.props).onTitleClick) === null || _item$props$onTitleCl3 === void 0 || _item$props$onTitleCl3.call(_item$props8, item.key, e);
            (_item$props$onClick6 = (_item$props9 = item.props).onClick) === null || _item$props$onClick6 === void 0 || _item$props$onClick6.call(_item$props9, e);
          }
        }));
      }
      // 无子菜单时
      return renderBaseMenuItem(item, {
        active: getSubmenuActive(item),
        selected: getMenuItemSelected(item),
        prefixCls: "".concat(prefixCls, "-horizontal"),
        onClick: function onClick(e) {
          var _item$props$onClick7, _item$props10;
          handleSelect({
            key: item.key,
            item: item.props,
            domEvent: e
          });
          (_item$props$onClick7 = (_item$props10 = item.props).onClick) === null || _item$props$onClick7 === void 0 || _item$props$onClick7.call(_item$props10, e);
        }
      });
    });
  };
  var renderMenuItem = function renderMenuItem() {
    if (mode === 'horizontal') {
      return renderHorizontalMenu(menuData);
    }
    if (mode === 'vertical') {
      return renderVerticalMenu(menuData);
    }
    return renderInlineMenu(menuData);
  };
  return /*#__PURE__*/_react.default.createElement(_MenuContext.MenuContextProvider, {
    prefixCls: prefixCls
  }, /*#__PURE__*/_react.default.createElement("ul", {
    style: style,
    className: (0, _classnames.default)(className, prefixCls, "".concat(prefixCls, "-").concat(theme), "".concat(prefixCls, "-").concat(mode), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-inline-collapsed"), mode === 'inline' && inlineCollapsed), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(size), !!size)),
    role: "menu"
  }, renderMenuItem()));
};
Menu.displayName = 'Menu';
var _default = exports.default = Menu;